import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';
import SectionHeader, { SectionHeaderTypes } from '../../Common/SectionHeader';

export default function SiteContactList({ contactList, pageSize = 10, selectedPage = 1, onSelectPage }) {
    const numberFormatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const [sortedBy, setSortedBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('desc');
    // const [selectedPage, setSelectedPage] = useState(1);
    // function handleSelectPage(pageNum) { setSelectedPage(pageNum); }
    // let selectAll = onSelectDoc && (<span className="selectAll" onClick={() => onSelectDoc()}><i className={selected ? "dhicon-check-2" : "dhicon-check-empty"} /><div>Select</div></span>);

    function handleSortByAndOrder(sortByAndOrder) {
        const [sortByParm, sortOrderParam] = sortByAndOrder.split("-");

        setSortOrder(sortOrderParam);
        setSortedBy(sortByParm);
    }

    function handleSortBy(sortBy) {
        let newSortOrder = sortOrder === 'desc' ? 'asc' : 'desc';

        setSortOrder(sortedBy === sortBy ? newSortOrder : 'desc');
        setSortedBy(sortBy);
    }

    function getSortComparer() {
        let isDesc = sortOrder === "desc";
        let compareFn = undefined;
        switch (sortedBy?.toLowerCase()) {
            case 'role':
                compareFn = (a, b) => (isDesc ? ('' + b.role).localeCompare(a.role) : ('' + a.role).localeCompare(b.role));
                break;
            case 'name':
                compareFn = (a, b) => (isDesc ? (`${b.first_Name} ${b.last_Name}`).localeCompare(`${a.first_Name} ${a.last_Name}`) : (`${a.first_Name} ${a.last_Name}`).localeCompare(`${b.first_Name} ${b.last_Name}`));
                break;
            case 'email':
            default:
                compareFn = (a, b) => (isDesc ? ('' + b.email).localeCompare(a.email) : ('' + a.email).localeCompare(b.email));
                break;
        }

        return compareFn;
    }

    let content;

    if (contactList.length > 0) {
        let compareFn = getSortComparer(sortedBy, sortOrder);
        let sortedList = contactList.toSorted(compareFn);

        let showncontactList = sortedList.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));

        let items = showncontactList.map((item, i) => {
            // let viewBtn = (<button className="button" onClick={() => viewDoc(item.latestRevision.imageUrl)}>View</button>);
            // let downloadBtn = (<button className="button" onClick={() => viewDoc(item.latestRevision.imageUrl, true)}>Download</button>);
            // let selectDoc = onSelectDoc && (<span className="select" onClick={() => onSelectDoc(item.id)}><i className={item.selected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);


            return (<tr key={`${i}`}>
                {/*<td className="compact">{selectDoc}</td>*/}
                <td className="">{item.role}</td>
                <td className="nowrap">{`${item.first_Name} ${item.last_Name}`}</td>
                <td className="nowrap">{item.email}</td>
                <td className="compact"><a className="button" href={`mailto:${item.email}`}>Contact</a></td>
                <td className="smallScreen text-[10pt]">
                    <div className="flex flex-col">
                        <div className="flex">
                            <span className="font-semibold w-14 shrink-0">Name: </span><span>{`${item.first_Name} ${item.last_Name}`}</span>
                        </div>
                        <div className="flex">
                            <span className="font-semibold w-14 shrink-0">Email: </span><span>{item.email}</span>
                        </div>
                        <div className="flex">
                            <span className="font-semibold w-14 shrink-0">Role: </span><span>{item.role}</span>
                        </div>
                        <div className="buttonContainer">
                            <a className="button" href={`mailto:${item.email}`}>Contact</a>
                        </div>
                    </div>
                </td>
            </tr>);
        });

        if (selectedPage > 1 && pageSize - items.length > 0) {
            let emptyRows = Array.from(
                { length: pageSize - items.length },
                (cv, i) => (<tr className="noBkg" key={`R${i}`}><td><button className="button hide">&nbsp;</button></td></tr>));
            items = items.concat(emptyRows);
        }

        let pagination = (<Pagination itemCount={contactList.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={onSelectPage} />);

        let sortSelect = (<select className="bg-drhPalette-secondary " onChange={(e) => handleSortByAndOrder(e.target.value)} value={`${sortedBy}-${sortOrder}`}>
            <option className="checked:font-semibold checked:text-white" value='role-desc'>Role desc</option>
            <option className="checked:font-semibold checked:text-white" value='role-asc'>Role asc</option>
            <option className="checked:font-semibold checked:text-white" value='name-desc'>Name desc</option>
            <option className="checked:font-semibold checked:text-white" value='name-asc'>Name asc</option>
            <option className="checked:font-semibold checked:text-white" value='email-desc'>Email desc</option>
            <option className="checked:font-semibold checked:text-white" value='email-asc'>Email asc</option>
        </select>);

        let sortBarSmallScreen = (<SectionHeader classes="selectAllSmallScreen m-1 pl-0.5 justify-end" sectionHeaderType={SectionHeaderTypes.Secondary}>
            <div className="text-base">
                <span className="hidden xsm:inline">Sort by</span>
                {sortSelect}
            </div>
        </SectionHeader>);

        let sortIconClass = sortOrder === 'desc' ? 'dhicon-down-open' : 'dhicon-up-open';

        //let sortableIcon = (<span className="flex"><i className="dhicon-up-open relative -top-1" /><i className="dhicon-down-open relative top-[3px] -left-[22.5px]" /></span>);
        //let sortableColDescClass = "relative -left-[22px]";
        let sortableIcon = (<i className="iconUpDown" />);
        let sortableColDescClass = "";

        let roleHeader = (<th onClick={() => handleSortBy('role')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'role' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'role' ? sortableColDescClass : ''}>Role</span>
            </div>
        </th>);

        let nameHeader = (<th onClick={() => handleSortBy('name')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'name' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'name' ? sortableColDescClass : ''}>Name</span>
            </div>
        </th>);

        let emailHeader = (<th onClick={() => handleSortBy('email')} className="cursor-pointer">
            <div className="flex">
                {sortedBy === 'email' ? (<i className={sortIconClass} />) : (sortableIcon)}
                <span className={sortedBy !== 'email' ? sortableColDescClass : ''}>Email</span>
            </div>
        </th>);

        content = items.length === 0 ? undefined : (<>
            {sortBarSmallScreen}
            <table className="itemList">
                <thead className="sticky top-0">
                    <tr>
                        {/*<th>{selectAll}</th>*/}
                        {roleHeader}
                        {nameHeader}
                        {emailHeader}
                        <th></th>
                    </tr>
                </thead>
                <tbody>{items}</tbody>
            </table>
            {/*pagination*/}
        </>);
    }

    return content;
}